(function () {
  'use strict';

  var SWYM_TIMEOUT = 8000;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var modal = document.getElementById('notify-me-modal');

  function t(key, fallback) {
    return (window.notifyStrings && window.notifyStrings[key]) || fallback;
  }

  function genericError() {
    return new Error(t('error_generic', 'Something went wrong. Please try again later.'));
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((value || '').trim());
  }

  function getSwym() {
    return new Promise(function (resolve, reject) {
      var settled = false;
      var timer = setTimeout(function () {
        if (settled) return;
        settled = true;
        console.warn('[notify-me] Swym Back in Stock did not load - is the app embed enabled?');
        reject(genericError());
      }, SWYM_TIMEOUT);

      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(function (swat) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        resolve(swat);
      });
    });
  }

  function subscribe(options) {
    return getSwym().then(function (swat) {
      var product = {
        empi: parseInt(options.productId, 10),
        epi: parseInt(options.variantId, 10),
        du: options.productUrl || window.location.href,
        pr: parseFloat(options.price) || 0,
        iu: options.image || ''
      };

      if (!product.pr || !product.iu) {
        console.warn('[notify-me] Subscribing without price and/or image:', product);
      }

      return new Promise(function (resolve, reject) {
        var onError = function (label) {
          return function (error) {
            console.error('[notify-me] Swym ' + label + ' failed:', error, 'payload:', product);
            reject(genericError());
          };
        };

        if (typeof swat.subscribeForProductAlert === 'function') {
          swat.subscribeForProductAlert(
            options.email,
            'email',
            product,
            resolve,
            onError('subscribeForProductAlert'),
            0,
            'backinstock'
          );
          return;
        }

        if (typeof swat.sendWatchlist === 'function') {
          console.warn('[notify-me] subscribeForProductAlert unavailable, falling back to sendWatchlist.');
          product.et = 8;
          swat.sendWatchlist(options.email, 'email', product, resolve, onError('sendWatchlist'), 0);
          return;
        }

        console.error('[notify-me] No Swym subscribe API found - check the Back in Stock app embed.');
        reject(genericError());
      });
    });
  }

  if (modal) {
    var form = modal.querySelector('.notify-form');
    var input = modal.querySelector('.notify-input');
    var errorEl = modal.querySelector('.notify-error');
    var successEl = modal.querySelector('.notify-success');
    var submitBtn = modal.querySelector('.notify-submit');
    var current = {};
    var lastTrigger = null;

    var showError = function (message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
      input.setAttribute('aria-invalid', 'true');
    };

    var clearError = function () {
      errorEl.textContent = '';
      errorEl.hidden = true;
      input.removeAttribute('aria-invalid');
    };

    var reset = function () {
      clearError();
      form.hidden = false;
      successEl.hidden = true;
      successEl.textContent = '';
      input.value = '';
      submitBtn.disabled = false;
    };

    var close = function () {
      if (modal.hidden) return;
      modal.hidden = true;
      document.body.classList.remove('open-notify');
      document.removeEventListener('keydown', onKeydown);
      if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
      lastTrigger = null;
    };

    var onKeydown = function (e) {
      if (e.key === 'Escape') {
        close();
        return;
      }
      if (e.key !== 'Tab') return;
      var focusable = Array.prototype.filter.call(
        modal.querySelectorAll(FOCUSABLE),
        function (el) { return el.offsetParent !== null; }
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };

    var open = function (options) {
      options = options || {};
      if (!options.variantId) {
        console.warn('[notify-me] open() called without a variantId.');
        return;
      }
      current = options;
      lastTrigger = options.trigger || document.activeElement;
      reset();
      modal.hidden = false;
      document.body.classList.add('open-notify');
      document.addEventListener('keydown', onKeydown);
      input.focus();
    };

    modal.querySelectorAll('[data-notify-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    modal.addEventListener('click', function (e) {
      if (e.target === modal) close();
    });

    input.addEventListener('input', clearError);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = input.value.trim();
      if (!isValidEmail(email)) {
        showError(t('error_email', 'Please enter a valid email address.'));
        input.focus();
        return;
      }
      submitBtn.disabled = true;
      subscribe({
        email: email,
        variantId: current.variantId,
        productId: current.productId,
        productUrl: current.productUrl,
        price: current.price,
        image: current.image
      })
        .then(function () {
          form.hidden = true;
          successEl.textContent = t('success', 'Thank you. We will email you as soon as this item is back in stock.');
          successEl.hidden = false;
        })
        .catch(function (err) {
          showError(err.message);
          submitBtn.disabled = false;
        });
    });

    document.addEventListener('click', function (e) {
      var chip = e.target && e.target.closest ? e.target.closest('[data-notify="true"]') : null;
      if (!chip) return;
      e.preventDefault();
      e.stopPropagation();
      var panel = chip.closest('.grid-quick-add');
      open({
        variantId: chip.dataset.id,
        productId: panel ? panel.dataset.productId : undefined,
        productUrl: panel ? panel.dataset.productUrl : undefined,
        price: panel ? panel.dataset.productPrice : undefined,
        image: panel ? panel.dataset.productImage : undefined,
        productTitle: chip.dataset.productTitle,
        trigger: chip
      });
    }, true);

    window.GBNotify = { open: open, close: close, subscribe: subscribe };
  } else {
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-notify="true"]')) {
        e.preventDefault();
        e.stopPropagation();
        console.warn('[notify-me] #notify-me-modal is not on the page - render the notify-me-popup snippet.');
      }
    }, true);

    window.GBNotify = { open: function () {}, close: function () {}, subscribe: subscribe };
  }

  function initPdpNotify() {
    document.querySelectorAll('.pdp-notify').forEach(function (block) {
      if (block.dataset.notifyBound === 'true') return;
      block.dataset.notifyBound = 'true';

      var pdpInput = block.querySelector('.notify-input');
      var pdpError = block.querySelector('.notify-error');
      var pdpSuccess = block.querySelector('.notify-success');
      var pdpSubmit = block.querySelector('.notify-submit');
      var wrapper = block.closest('.snippet-addto-cart') || document;

      pdpInput.addEventListener('input', function () {
        pdpError.hidden = true;
        pdpInput.removeAttribute('aria-invalid');
      });

      pdpSubmit.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = block.dataset.variantId;
        if (!variantId) {
          pdpError.textContent = t('error_size', 'Please select a size first.');
          pdpError.hidden = false;
          wrapper.classList.add('product-form-notify-error');
          return;
        }
        wrapper.classList.remove('product-form-notify-error');

        var email = pdpInput.value.trim();
        if (!isValidEmail(email)) {
          pdpError.textContent = t('error_email', 'Please enter a valid email address.');
          pdpError.hidden = false;
          pdpInput.setAttribute('aria-invalid', 'true');
          pdpInput.focus();
          return;
        }

        pdpSubmit.disabled = true;
        subscribe({
          email: email,
          variantId: variantId,
          productId: block.dataset.productId,
          productUrl: block.dataset.productUrl,
          price: block.dataset.variantPrice || block.dataset.productPrice,
          image: block.dataset.productImage
        })
          .then(function () {
            block.querySelector('.pdp-notify-form').hidden = true;
            pdpSuccess.textContent = t('success', 'Thank you. We will email you as soon as this item is back in stock.');
            pdpSuccess.hidden = false;
          })
          .catch(function (err) {
            pdpError.textContent = err.message;
            pdpError.hidden = false;
            pdpSubmit.disabled = false;
          });
      });
    });
  }

  // On desktop .sticky-info centres its content vertically, so swapping the
  // add-to-cart button for the taller notify form would push everything above
  // it upwards. Pad the top by the extra height so the content stays in place
  // and the form grows downwards instead (as far as the viewport allows).
  function keepPdpInfoInPlace(block) {
    var info = block.closest('.sticky-info');
    if (!info) return;
    info.style.removeProperty('--pdp-notify-offset');

    if (block.hidden) {
      block.parentNode.querySelectorAll('.choose-cart, .choose-selector').forEach(function (el) {
        if (el.offsetHeight) block.dataset.ctaHeight = el.offsetHeight;
      });
      return;
    }
    if (getComputedStyle(info).justifyContent !== 'center') return;

    var first = Array.prototype.filter.call(info.children, function (el) { return el.getClientRects().length; })[0];
    if (!first) return;
    var replaced = parseFloat(block.dataset.ctaHeight) || block.querySelector('.notify-submit').offsetHeight;
    var extra = block.offsetHeight + parseFloat(getComputedStyle(block).marginTop) - replaced;
    var free = 2 * (first.getBoundingClientRect().top - info.getBoundingClientRect().top);
    var offset = Math.min(extra, free);
    if (offset > 0) info.style.setProperty('--pdp-notify-offset', offset + 'px');
  }

  function syncPdpNotifyToVariant() {
    var block = document.querySelector('.pdp-notify');
    if (!block || block.dataset.syncBound === 'true') return;
    block.dataset.syncBound = 'true';

    // Fires after layout but before paint, once product.js has swapped the buttons.
    if (window.ResizeObserver) {
      new ResizeObserver(function () { keepPdpInfoInPlace(block); }).observe(block);
    }

    var variants = [];
    var json = document.querySelector('variant-radios script[type="application/json"]');
    if (json) {
      try { variants = JSON.parse(json.textContent); } catch (e) { variants = []; }
    }

    var update = function () {
      var checked = document.querySelectorAll('variant-radios input[type="radio"]:checked');
      var match = null;

      if (checked.length) {
        var selected = Array.prototype.map.call(checked, function (i) { return i.value; });
        match = variants.filter(function (variant) {
          return selected.every(function (value) { return variant.options.indexOf(value) !== -1; });
        })[0];
      }

      if (!match || match.available) {
        block.hidden = true;
        block.removeAttribute('data-variant-id');
        return;
      }

      block.dataset.variantId = match.id;
      if (typeof match.price === 'number') block.dataset.variantPrice = match.price / 100;
      if (match.featured_image && match.featured_image.src) block.dataset.productImage = match.featured_image.src;
      block.hidden = false;
    };

    var radios = document.querySelector('variant-radios');
    if (radios) radios.addEventListener('change', update);
    update();
  }

  function init() {
    initPdpNotify();
    syncPdpNotifyToVariant();
  }

  window.GBNotify.refresh = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
